import { render, staticRenderFns } from "./NewConversation.vue?vue&type=template&id=fee1de2e&scoped=true"
import script from "./NewConversation.vue?vue&type=script&lang=js"
export * from "./NewConversation.vue?vue&type=script&lang=js"
import style0 from "./NewConversation.vue?vue&type=style&index=0&id=fee1de2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee1de2e",
  null
  
)

export default component.exports